<template>
    <div>

        <TextBanner>
        Die Raumstation besteht aus vielen <b>Einzelmodulen</b> unterschiedlicher Raumfahrtagenturen.<p></p>

        <p>Wenn Sie den türkisen Punkt drücken, können Sie die Station zerlegen. Finden Sie durch Drehen des Modells die <b>Kontur der ISS</b> zum Größenvergleich.</p>
        </TextBanner>

        <InfoBox modalName="IB_Anim">
            <template #title></template>
            <template #subline></template>
            <template>
            </template>
        </InfoBox>

        <InfoBox modalName="IB_Halo">
            <template #title>Das Fundament der neuen Station</template>
            <template #subline></template>
            <template>
                Das Power- and Propulsion Element <b>PPE</b> und der Habitation and Logistics Outpost <b>HALO</b> der Nasa bilden die Grundlage. Das PPE ist für wesentliche Teile der Stromversorgung, der Kommunikation und der Steuerung zuständig.
                     <p><br><b>HALO</b> ist eine Art Kommando-Modul, in dem die Astronauten arbeiten und leben können. </p>

            </template>
        </InfoBox>

        <InfoBox modalName="IB_Esa">
            <template #title>Hightech von der Esa</template>
            <template #subline></template>
            <template>
                <p>Auch die Esa liefert wesentliche Bestandteile. Zentral ist das Versorgungsmodul für die neuen <b>Orion-Raumschiffe</b>. Es ist für Antrieb und Steuerung zuständig und regelt die Energieversorgung der Raumkapsel. 
                    Darüber hinaus regelt es die Trinkwasser- und Sauerstoffversorgung und kontrolliert die Temperatur.  </p>

                <p>Auch das IHab- und das ESPRIT-Modul stammen von der Esa. IHab steht für International Habitation Modul und wird der Wohn- und Lebensbereich der Astronauten. ESPRIT ist u.a. für Kommunikation mit der Mond-Basisstation und für die Betankung der Raumschiffe zuständig. 
                    Und es bietet wieder einen kuppelförmigen Ausguck wie auf der ISS.</p>

            </template>
        </InfoBox>

        <InfoBox modalName="IB_Jaxa">
            <template #title>Unterstützung durch Jaxa</template>
            <template #subline></template>
            <template>
                <p>Die japanische Weltraumagentur Jaxa arbeitet u.a. bei der Entwicklung von <b>IHab</b> und <b>HALO</b> mit. 
                    Außerdem soll sie Versorgungsflüge zu der Station übernehmen und dafür Transporter entwickeln. </p>

            </template>
        </InfoBox>

        <InfoBox modalName="IB_Csa">
            <template #title>Roboter-Technik von der Csa</template>
            <template #subline></template>
            <template>
                <p>Die Kanadier liefern u.a. einen <b>Roboterarm</b> für das Gateway und sind für Robotertechnik u.a. an den Docking-Stellen der Station zuständig.</p>

            </template>
        </InfoBox>

        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('TolleInfoBox')"></div>
        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                betaLimits: [.1, 3.14],
                position: [-2.1,.7,50],   //[-1.57,0,50],  schräg -8.8,0.45,50  von oben [-1.57,0,200    schräg bei fov.1 -8.8,1,300  //von oben fov.6 -7.85,0.2,60
                target: [0,0,-3],
                clipping:[2,100000],
              radiusLimits: [15,150],   //bei fov.15+Pos -8.2,0.2,300 + radiusLimit 10,500
                fov:.6,  //.15
                animationSpeed: .1,
                useAutoRotationBehavior: false,
            },

            artemis_geo: {
                scaling: [1,1,-1],

                Sonne: {
                    fade: true,
                    visible: false
                    },

                Power:{ 
                    pickable: false,
                },
                Logistics:{
                    pickable: false
                },
                Airlock:{
                    pickable: false
                },
                Lander:{
                    pickable: false
                },
                Halo:{
                    pickable: false
                },
                Habitation:{
                    pickable: false
                },
                Esprit:{
                    pickable: false
                },
                Canadarm:{
                    pickable: false
                },

                Mars:{
                    visible: false
                },
                Mond:{
                    visible:false
                },
                 Weltall: {                            
                    fade: false,
                    visible: false,
                    },

                Plane_Bezeichnungen:{
                    //renderingGroupId:1,
                    visible: true,
                    pickable: false,
                },

                // Station_All:{
                //     Empty:{
                //         Orion:{
                //             pickable: false,
                //             Label_Orion:{
                //                 Text_Orion:{
                //                     renderingGroupId:0
                //                 },
                //                 renderingGroupId:0,
                //                 visible: false,
                //                 billboardMode: 7,
                //                 }
                //             }
                //     }
                // }, 

                iss_kontur:{
                    visible: true,
                    pickable: false,
                },
            },
            

            hotspots: {
                info_7: {
                    visible: true,
                    //renderingGroupId:1,
                    infoBox: 'IB_Halo',
                    position: [0, 2, 0],
                    scale: 3,
                },

                info_8: {
                    visible: true,
                    //renderingGroupId:1,
                    infoBox: 'IB_Esa',
                    position: [0, 2, -10],
                    scale: 3
                },

                info_9: {
                    visible: true,
                    //renderingGroupId:1,
                    infoBox: 'IB_Jaxa',
                    position: [0, 2, -3.5],
                    scale: 3,
                },

                info_10: {
                    visible: true,
                    //renderingGroupId:1,
                    position: [1, 2.7, 3.5],
                    scale: 3,
                    trigger: (babylonController) => {
                            babylonController.moveCamera(-2.1,.7,20,0,0,0);                   
                    },  //funktioniert nur, wenn infoBox:'IB_Csa' ausgeschaltet ist. scheint, als ob die Infobox die Animation blockiert
                    infoBox: 'IB_Csa',

                },


                info_anim: {
                    visible: true,
                    //renderingGroupId:1,
                    //infoBox: 'IB_Anim',
                    position: [1, 12, -3],
                    scale: 4,
                    imgUrl: 'texture/hotspotSprite.png', // optional

                    trigger: (babylonController) => {
                            babylonController.goToAnimation("anim_orion_ankommen", 50);

                            babylonController.startAnimation("anim_overlay", false, 1.6);

                            babylonController.startAnimation("anim_power", false, .6);
                            babylonController.startAnimation("anim_lander", false, .6);
                            babylonController.startAnimation("anim_canadarm", false, .6);
                            babylonController.startAnimation("anim_logistics", false, .6);
                            babylonController.startAnimation("anim_habitation", false, .6);
                            babylonController.startAnimation("anim_orion", false, .6);
                            babylonController.startAnimation("anim_esprit", false, .6);
                            babylonController.startAnimation("anim_halo", false, .6);
                            babylonController.startAnimation("anim_airlock", false, .6);   
                            
                            babylonController.moveCamera(-2.1,.7,50,0,0,-3);
                            //babylonController.camera.setPosition(-4,1,20)
                            //babylonController.camera.setTarget(0,0,1);
                            
                    },
                },
            },
        },

        babylonReady: function () {

        this.$babylonController.goToAnimation("anim_orion_ankommen", 50);
        this.$babylonController.goToAnimation("anim_overlay", 0);

        this.$babylonController.goToAnimation("anim_power", 0);
        this.$babylonController.goToAnimation("anim_lander", 0);
        this.$babylonController.goToAnimation("anim_canadarm", 0);
        this.$babylonController.goToAnimation("anim_logistics", 0);
        this.$babylonController.goToAnimation("anim_habitation", 0);
        this.$babylonController.goToAnimation("anim_orion", 0);
        this.$babylonController.goToAnimation("anim_esprit", 0);
        this.$babylonController.goToAnimation("anim_halo", 0);
        this.$babylonController.goToAnimation("anim_airlock", 0);


        // this.$babylonController.startAnimation("anim_power", false, .4);
        // this.$babylonController.startAnimation("anim_lander", false, .4);
        // this.$babylonController.startAnimation("anim_canadarm", false, .4);
        // this.$babylonController.startAnimation("anim_logistics", false, .4);
        // this.$babylonController.startAnimation("anim_habitation", false, .4);
        // this.$babylonController.startAnimation("anim_orion", false, .4);
        // this.$babylonController.startAnimation("anim_esprit", false, .4);
        // this.$babylonController.startAnimation("anim_halo", false, .4);
        // this.$babylonController.startAnimation("anim_airlock", false, .4);

        },
    }

</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
